// src/belediye/components/tasks/GorevFiltreleri.js
// FAZ-56 — FilterSheet içine giren ortak filtre alanları.
//
// Görsel dil Başvurular sayfasının filtre paneliyle AYNI (.afp-* sınıfları
// ApplicationsPage.css'te tanımlı ve PageHeader tarafından yükleniyor) — yeni
// bir filtre dili icat edilmedi.
//
// 2026-07-28 (kullanıcı kararı): "atanan kişi / birim" seçicisi KALDIRILDI —
// kişi ve birim araması arama çubuğundan yapılıyor, filtre panelinde ikinci bir
// arama kutusu gereksiz. Yerine TERMİN aralığı eklendi.

import React from "react";

import "./gorev.css";

const ONCELIKLER = [
  { key: "dusuk", label: "Düşük" },
  { key: "normal", label: "Normal" },
  { key: "yuksek", label: "Yüksek" },
  { key: "kritik", label: "Kritik" },
];

function TarihCifti({ baslik, ipucu, fromValue, toValue, onFrom, onTo }) {
  return (
    <div className="afp-section">
      <div className="afp-label">{baslik}</div>
      {ipucu ? <div className="gk-filtre-ipucu">{ipucu}</div> : null}
      <div className="afp-dates">
        <input
          type="date"
          className="md-input"
          value={fromValue}
          onChange={(e) => onFrom(e.target.value)}
          aria-label={`${baslik} — başlangıç`}
        />
        <span className="afp-dates-sep">–</span>
        <input
          type="date"
          className="md-input"
          value={toValue}
          onChange={(e) => onTo(e.target.value)}
          aria-label={`${baslik} — bitiş`}
        />
      </div>
    </div>
  );
}

export function TarihAraligi({ filtreler, yamala }) {
  return (
    <TarihCifti
      baslik="Ne zaman verildi"
      fromValue={filtreler.dateFrom}
      toValue={filtreler.dateTo}
      onFrom={(v) => yamala({ dateFrom: v })}
      onTo={(v) => yamala({ dateTo: v })}
    />
  );
}

export function SureAraligi({ filtreler, yamala }) {
  return (
    <TarihCifti
      baslik="Teslim tarihi"
      ipucu="Talebin bitmesi gereken tarihe göre"
      fromValue={filtreler.dueFrom}
      toValue={filtreler.dueTo}
      onFrom={(v) => yamala({ dueFrom: v })}
      onTo={(v) => yamala({ dueTo: v })}
    />
  );
}

export function OncelikSecici({ filtreler, yamala }) {
  const secili = Array.isArray(filtreler.priority) ? filtreler.priority : [];
  const degistir = (key) =>
    yamala({
      priority: secili.includes(key)
        ? secili.filter((k) => k !== key)
        : [...secili, key],
    });
  return (
    <div className="afp-section">
      <div className="afp-label">
        Aciliyet
        {secili.length > 0 && <span className="afp-count">{secili.length}</span>}
      </div>
      <div className="gk-chips">
        {ONCELIKLER.map((o) => (
          <button
            key={o.key}
            type="button"
            className={`gk-chip ${secili.includes(o.key) ? "is-active" : ""}`}
            onClick={() => degistir(o.key)}
          >
            {o.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export function BasvuruBagi({ filtreler, yamala }) {
  const secenekler = [
    { key: "", label: "Hepsi" },
    { key: "1", label: "Bir başvurudan doğan" },
    { key: "0", label: "Kendi başına verilen" },
  ];
  return (
    <div className="afp-section">
      <div className="afp-label">Talebin kaynağı</div>
      <div className="gk-chips">
        {secenekler.map((s) => (
          <button
            key={s.key || "hepsi"}
            type="button"
            className={`gk-chip ${filtreler.hasApplication === s.key ? "is-active" : ""}`}
            onClick={() => yamala({ hasApplication: s.key })}
          >
            {s.label}
          </button>
        ))}
      </div>
    </div>
  );
}

// Yalnız "Tamamlanan" çipi seçiliyken anlamlı — diğerlerinde gizlenir.
export function TamamlanmaPenceresi({ filtreler, yamala, cip }) {
  if (cip !== "tamamlanan") return null;
  const secenekler = [
    ["7", "Son 7 gün"],
    ["30", "Son 30 gün"],
    ["all", "Tüm zamanlar"],
  ];
  return (
    <div className="afp-section">
      <div className="afp-label">Ne kadar geriye bakılsın</div>
      <div className="gk-chips">
        {secenekler.map(([key, label]) => (
          <button
            key={key}
            type="button"
            className={`gk-chip ${(filtreler.completedWindow || "7") === key ? "is-active" : ""}`}
            onClick={() => yamala({ completedWindow: key })}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}

// İki sayfanın da kullandığı standart filtre seti — tek yerden.
export function OrtakFiltreler({ filtreler, yamala, cip }) {
  return (
    <>
      <SureAraligi filtreler={filtreler} yamala={yamala} />
      <TarihAraligi filtreler={filtreler} yamala={yamala} />
      <OncelikSecici filtreler={filtreler} yamala={yamala} />
      <BasvuruBagi filtreler={filtreler} yamala={yamala} />
      <TamamlanmaPenceresi filtreler={filtreler} yamala={yamala} cip={cip} />
    </>
  );
}
